import React from 'react'
import {
  H4, H5, Button, Div, P, Icon,
} from 'konsys-ui'
import {
  UploadWrapper,
} from './styled'
import { theme } from '../../../styles/_variables'

const UploadFile = props => (
  <Div>
    <UploadWrapper>
      <input
        id={props.id}
        type='file'
        multiple={props.multiple}
        alt=""
        onClick={(e) => {
          e.target.value = null
        }}
        onChange={e => props.onChange(e.target.files)}
        accept={props.fileType}
        ref={(el) => { this.inputFile = el }}
      />
      <label htmlFor={props.id}>
        <H4 display='block' textAlign='center' color={theme.color.grey}>ลากไฟล์ลงที่นี่</H4>
        <H5 display='block' textAlign='center' margin='0 0 8px' color={theme.color.paleGray}>- หรือ -</H5>
        <Button style={{ fontSize: theme.fonts.size.subTitle }} fontSize={theme.fonts.size.subTitle} color={theme.color.paleBlack} buttonStyle='rectangle' text='คลิกเพื่อค้นหาไฟล์' />
      </label>
    </UploadWrapper>
    <Div margin='8px 0'>
    {
      props.list && props.list.length >= 1 && props.list.map((v, index) => (
        <Div margin='8px 0' key={v.name} display='flex' justifyContent='space-between' moreStyle={{
          maxHeight: '100px',
          overflow: 'auto',
        }}>
          <P color='rgba(0, 0, 0, 0.65)'>{v.name}</P>
          <Icon onClick={() => props.onRemoveFile(v.name)} style={{ cursor: 'pointer' }} color='rgba(0, 0, 0, 0.65)' icon='far fa-times' />
        </Div>
      ))
    }
    </Div>
  </Div>
)

export default UploadFile



// WEBPACK FOOTER //
// ./src/components/common/upload/index.jsx